import { Text3D, Center } from "@react-three/drei"
import { useAtomValue } from "jotai";
import { useRef } from "react"
import * as THREE from 'three';
import { useParams } from "wouter";
import { clientAtom, languageAtom } from "../GlobalState";
import { getSocket } from "../socket.js";
import translations from "../dictionaries/translations";

const socket = getSocket();
import { trackEvent } from "../api";
import layout from "../dictionaries/layout";

export default function PlayAgainButton({ rotation, position, device='landscapeDesktop', preview=false }) {
  
  const language = useAtomValue(languageAtom)
  const fontUrl = language === 'korean' ? "/fonts/Maplestory_Bold.json" : language === 'chinese' ? "/fonts/Xiao Xiangjiao font_Regular.json" : "/fonts/Luckiest Guy_Regular.json"

  const playAgainTextMaterialRef = useRef()
  const playAgainBoxMaterialRef = useRef()
  const lastPlayAgainAtRef = useRef(0)
  function handlePlayAgainPointerEnter(e) {
    e.stopPropagation()
    playAgainTextMaterialRef.current.color = new THREE.Color('green')
    playAgainBoxMaterialRef.current.color = new THREE.Color('green')
    document.body.style.cursor = "pointer";
  }
  function handlePlayAgainPointerLeave(e) {
    e.stopPropagation()
    playAgainTextMaterialRef.current.color = new THREE.Color('yellow')
    playAgainBoxMaterialRef.current.color = new THREE.Color('yellow')
    document.body.style.cursor = "default";
  }
  const params = useParams();
  const client = useAtomValue(clientAtom)
  async function handlePlayAgainPointerUp(e) {
    e.stopPropagation()

    const now = Date.now()
    if (preview || now - lastPlayAgainAtRef.current < 500) return
    lastPlayAgainAtRef.current = now
    socket.emit('reset', { roomId: params.id.toUpperCase(), clientId: client._id })
    await trackEvent({ surface: 'end_scene', action: 'play_again', category: 'gameplay' })
  }

  return <group name='play-again-button' rotation={rotation} position={position}>
    <mesh>
      <boxGeometry args={layout[device].endSceneActionButtons.playAgainButton.outerBox.args}/>
      <meshStandardMaterial ref={playAgainBoxMaterialRef} color='yellow'/>
    </mesh>
    <mesh>
      <boxGeometry args={layout[device].endSceneActionButtons.playAgainButton.innerBox.args}/>
      <meshStandardMaterial color='black'/>
    </mesh>
    <mesh
      name='play-again-button-wrapper'
      onPointerEnter={(e) => handlePlayAgainPointerEnter(e)}
      onPointerLeave={(e) => handlePlayAgainPointerLeave(e)}
      onPointerUp={(e) => handlePlayAgainPointerUp(e)}
    >
      <boxGeometry args={layout[device].endSceneActionButtons.playAgainButton.wrapper.args}/>
      <meshStandardMaterial color="grey" transparent opacity={0}/>
    </mesh>
    <Center position={[0, 0, layout[device].endSceneActionButtons.playAgainButton.text.position[2]]}>
      <Text3D
        font={fontUrl}
        size={layout[device].endSceneActionButtons.playAgainButton.text.fontSize}
        height={0.03} 
      >
        {translations.endScenes.playAgain[language]}
        <meshStandardMaterial ref={playAgainTextMaterialRef} color='yellow' />
      </Text3D>
    </Center>
  </group>
}